import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

type DeleteProjectResponse = {
  status: string;
  message: string;
  id: string;
};
type DeleteProjectVariables = { id: string };

const useDeleteProject = (
  options?: UseMutationOptions<
    DeleteProjectResponse,
    Error,
    DeleteProjectVariables
  >
) => {
  return useMutation<DeleteProjectResponse, Error, DeleteProjectVariables>({
    mutationFn: async (
      variables: DeleteProjectVariables
    ): Promise<DeleteProjectResponse> => {
      const { id } = variables;
      const URL = `${import.meta.env.VITE_API_PROJECTS_URL}/${id}`;
      const { data } = await axiosClient.delete<DeleteProjectResponse>(URL);
      return { ...data, id: variables.id };
    },
    ...options,
  });
};

export default useDeleteProject;
